/* eslint-disable */
// /src/services/homeConfigService.js

import {
    doc, getDoc, setDoc, serverTimestamp, onSnapshot, runTransaction
} from "firebase/firestore";


import { db, storage } from "./firebase";


const COLLECTION = "home_config";
const DRAFT_ID = "draft";
const PUBLISHED_ID = "published";

export async function getDraft() {
    const ref = doc(db, COLLECTION, DRAFT_ID);
    const snap = await getDoc(ref);
    return snap.exists() ? snap.data() : null;
}

export async function saveDraft(config, user) {
    const ref = doc(db, COLLECTION, DRAFT_ID);
    const data = {
        ...config,
        savedAt: serverTimestamp(),
        savedBy: user?.uid || user?.phoneE164 || "admin",
    };
    await setDoc(ref, data, { merge: true });
    return true;
}

export async function publishDraft(user) {
    const draftRef = doc(db, COLLECTION, DRAFT_ID);
    const pubRef = doc(db, COLLECTION, PUBLISHED_ID);
    await runTransaction(db, async (tx) => {
        const draftSnap = await tx.get(draftRef);
        const draft = draftSnap.exists() ? draftSnap.data() : null;
        if (!draft) throw new Error("No draft to publish");
        const data = {
            ...draft,
            updatedAt: serverTimestamp(),
            updatedBy: user?.uid || user?.phoneE164 || "admin",
        };
        tx.set(pubRef, data, { merge: true });
    });
    return true;
}

export function subscribePublished(cb) {
    const ref = doc(db, COLLECTION, PUBLISHED_ID);
    return onSnapshot(ref, (snap) => {
        cb(snap.exists() ? snap.data() : null);
    });
}



export async function getPublishedOnce() {

    const ref = doc(db, "home_config", "published");
    const snap = await getDoc(ref);

    console.log("getPublishedOnce snap:", snap);
    return snap.exists() ? snap.data() : null;
}
